// extracted by mini-css-extract-plugin
export default {"badge":"EnrollmentAccessBadge_badge__Kds7x","full":"EnrollmentAccessBadge_full__lLWc8"};